import React from 'react';
import API from '../../../utils/API';
import InputField from '../../../components/inputs/inputField';
import FieldModal from '../../../components/modals/fieldModal';
import { withRouter } from 'react-router-dom';

class DuplicateFormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name ? `${props.name} (Copy)` : '',
            submitting: false,
            requiredFields: { name: false }
        };
    }

    duplicateForm = async () => {
        this.setState({ submitting: true });
        const { name } = this.state;
        const { orgId, formId } = this.props;
        if (!name) {
            this.setState({ submitting: false, requiredFields: { name: true } });
            return;
        }
        await API()
            .post(`Organizations/${orgId}/accountForms/${formId}/duplicate`, { name })
            .then((res) => {
                if (res.data) {
                    window.open(`/${orgId}/forms/${res.data._id}`, '_self');
                }
            })
            .catch(() => this.setState({ submitting: false }));
    };

    render() {
        const { isOpen, toggle } = this.props;
        const { submitting, name, requiredFields } = this.state;
        return (
            <FieldModal
                size="small"
                isOpen={isOpen}
                modalTitle="Duplicate Form"
                bodyHeaderText="Enter a name for the duplicated form."
                bodyContent={() => (
                    <InputField
                        label="Name"
                        value={name}
                        required={true}
                        errorTrigger={requiredFields.name}
                        onChange={(e) => this.setState({ name: e.target.value })}
                    />
                )}
                toggle={toggle}
                actionButtonLabel={submitting ? 'Duplicating...' : 'Duplicate'}
                cancelButtonLabel="Cancel"
                actionButton={this.duplicateForm}
                submitting={submitting}
                actionButtonDisabled={submitting}
            />
        );
    }
}

export default withRouter(DuplicateFormModal);
